import CloseIcon from '@mui/icons-material/Close';
import { Button, Fab, Link, Paper, Stack, Typography } from '@mui/material';
import { FC } from 'react';
import { SuccessRegistration } from '../../assets/images';
import { getMilitaryTime, getReadableDate } from '../../helpers/time';
import './successful-registration.css';

type Props = {
  appointmentType: {
    name: string;
  };
  booking: {
    time: string;
  };
  onExploreMoreGroupClasses: () => void;
};

const SuccessfulRegistration: FC<Props> = ({
  appointmentType,
  booking,
  onExploreMoreGroupClasses,
}) => {
  return (
    <Stack className='successful-registration-page'>
      <Stack className='main-content'>
        <Stack>
          <img src={SuccessRegistration} alt='header-icon' />
        </Stack>
        <Typography>Registration completed for</Typography>
        <Typography variant='h3' component='p'>
          {appointmentType.name}
        </Typography>
        <Typography>
          See you on {getReadableDate(booking.time)} at {getMilitaryTime(booking.time)}
        </Typography>
        <Typography>Manage Group Classes in the Enara App</Typography>
        <Link href='com.enara://' underline='none'>
          Close this window
        </Link>
      </Stack>
      <Paper className='actions' elevation={10}>
        <Button variant='contained' onClick={onExploreMoreGroupClasses}>
          Register for Another Class
        </Button>
      </Paper>
      <Fab className='fab-action' size='small' href='com.enara://'>
        <CloseIcon fontSize='small' />
      </Fab>
    </Stack>
  );
};

export default SuccessfulRegistration;
